export enum ApiMemberDataFieldName {
  Status = "Status",
  Gender = "Gender",
  MemberLevel = "MemberLevel",
  MemberLevelDescription = "MemberLevelDescription",
  MembershipType = "MembershipType",
  MembershipTypeDescription = "MembershipTypeDescription",
}
